// ============================================================
// MOCK / FALLBACK DATA SERVICE — TAKEAWAY PLATFORM ONLY
// No delivery partners, no delivery zones, no rider data.
// Used as fallback when backend is unreachable.
// ============================================================

import { STATUS, ROLES } from '../utils/constants';

const RESTAURANTS = [
  'Spice Garden','Biryani House','Curry Palace','Tandoor Express','Masala Kitchen',
  'Royal Biryani',"Nawab's Kitchen",'Hyderabadi Darbar','Paradise Biryani','Dum Pukht',
];
const CUSTOMERS = [
  'Rahul Sharma','Priya Patel','Amit Kumar','Sneha Reddy','Vikram Singh',
  'Deepa Nair','Rajesh Gupta','Kavya Menon','Suresh Iyer','Anita Desai',
];
const CITIES = ['Hyderabad','Bangalore','Mumbai','Chennai','Delhi'];
const PICKUP_STATUSES = ['pending','accepted','preparing','ready','completed','cancelled','rejected'];

export const getDashboardStats = () => ({
  totalUsers:12847, activeRestaurants:342, ordersToday:1284,
  revenueToday:284650, monthlyRevenue:7842300, pendingVerifications:28,
  supportTickets:43, commissionEarnings:942180, cancellationsToday:87,
  rejectionsToday:52, newUsersThisMonth:1247, avgOrderValue:485,
  totalOrders:284750, platformGrowth:18.4,
  readyForPickupNow:47, pendingPickupOrders:118, avgPrepTime:22,
  pickupCompletionRate:94.2, ordersAwaitingAccept:23, avgPickupDelay:4.5,
  peakHour:'1:00 PM', topRestaurantToday:'Biryani House',
});

export const getRevenueChartData = () => [
  {month:'Jan',revenue:4200000,orders:8200,commission:504000},
  {month:'Feb',revenue:3800000,orders:7400,commission:456000},
  {month:'Mar',revenue:5100000,orders:9800,commission:612000},
  {month:'Apr',revenue:5600000,orders:10200,commission:672000},
  {month:'May',revenue:6200000,orders:11400,commission:744000},
  {month:'Jun',revenue:7100000,orders:13200,commission:852000},
  {month:'Jul',revenue:6800000,orders:12800,commission:816000},
  {month:'Aug',revenue:7400000,orders:14100,commission:888000},
  {month:'Sep',revenue:6900000,orders:13500,commission:828000},
  {month:'Oct',revenue:7800000,orders:15200,commission:936000},
  {month:'Nov',revenue:8200000,orders:16100,commission:984000},
  {month:'Dec',revenue:9100000,orders:17800,commission:1092000},
];

export const getOrderTrendData = () => [
  {day:'Mon',orders:1200,cancelled:87,pickedUp:1050},
  {day:'Tue',orders:1450,cancelled:102,pickedUp:1290},
  {day:'Wed',orders:1100,cancelled:78,pickedUp:980},
  {day:'Thu',orders:1680,cancelled:120,pickedUp:1490},
  {day:'Fri',orders:1920,cancelled:145,pickedUp:1710},
  {day:'Sat',orders:2340,cancelled:189,pickedUp:2080},
  {day:'Sun',orders:2100,cancelled:162,pickedUp:1870},
];

export const getPickupStatusBreakdown = () => [
  {name:'Picked Up On Time',value:72,color:'#10B981'},
  {name:'Picked Up Late',value:16,color:'#F59E0B'},
  {name:'Not Picked Up',value:7,color:'#EF4444'},
  {name:'Cancelled',value:5,color:'#6B7280'},
];

export const getPreparationTimeData = () => [
  {restaurant:'Spice Garden',avgMinutes:18,target:20,efficiency:94},
  {restaurant:'Biryani House',avgMinutes:24,target:20,efficiency:78},
  {restaurant:'Curry Palace',avgMinutes:16,target:20,efficiency:98},
  {restaurant:'Tandoor Express',avgMinutes:22,target:20,efficiency:86},
  {restaurant:'Masala Kitchen',avgMinutes:19,target:20,efficiency:91},
  {restaurant:'Royal Biryani',avgMinutes:28,target:20,efficiency:68},
  {restaurant:"Nawab's Kitchen",avgMinutes:21,target:20,efficiency:89},
  {restaurant:'Hyderabadi Darbar',avgMinutes:15,target:20,efficiency:99},
];

export const getPeakHoursData = () => [
  {hour:'8 AM',orders:42},{hour:'9 AM',orders:87},{hour:'10 AM',orders:130},
  {hour:'11 AM',orders:210},{hour:'12 PM',orders:340},{hour:'1 PM',orders:420},
  {hour:'2 PM',orders:310},{hour:'3 PM',orders:180},{hour:'4 PM',orders:95},
  {hour:'5 PM',orders:150},{hour:'6 PM',orders:280},{hour:'7 PM',orders:390},
  {hour:'8 PM',orders:360},{hour:'9 PM',orders:240},{hour:'10 PM',orders:110},
];

export const getCustomerGrowthData = () => [
  {month:'Jan',newCustomers:820,returning:4200},
  {month:'Feb',newCustomers:940,returning:4600},
  {month:'Mar',newCustomers:1100,returning:5200},
  {month:'Apr',newCustomers:1050,returning:5800},
  {month:'May',newCustomers:1247,returning:6400},
  {month:'Jun',newCustomers:1380,returning:7100},
];

export const getPickupQueue = () => Array.from({length:30},(_,i)=>{
  const prepMins=15+(i%15);
  const placedMinsAgo=i*3+Math.floor(Math.random()*5);
  const status=PICKUP_STATUSES[i%7];
  const placedAt=new Date(Date.now()-placedMinsAgo*60000).toISOString();
  return {
    id:`QUEUE${String(i+1).padStart(4,'0')}`,
    orderId:`ORD${String(100000+i)}`,
    pickupToken:`TKN${String(1000+i)}`,
    customerName:CUSTOMERS[i%10],
    customerPhone:`+91 ${9000000000+i}`,
    restaurantName:RESTAURANTS[i%10],
    itemCount:Math.floor(Math.random()*5)+1,
    totalAmount:Math.floor(Math.random()*1500)+200,
    status,
    placedAt,
    estimatedReadyAt:new Date(Date.now()+(prepMins-placedMinsAgo)*60000).toISOString(),
    prepTimeMinutes:prepMins,
    elapsedMinutes:placedMinsAgo,
    isLate:placedMinsAgo>prepMins&&status==='ready',
    paymentStatus:['paid','paid','paid','pending'][i%4],
  };
});

export const getUsers = () => Array.from({length:50},(_,i)=>({
  id:`USR${String(i+1).padStart(4,'0')}`,name:CUSTOMERS[i%10],
  email:`user${i+1}@example.com`,phone:`+91 ${9000000000+i}`,
  role:Object.values(ROLES)[i%6],status:[STATUS.ACTIVE,STATUS.INACTIVE,STATUS.SUSPENDED][i%3],
  createdAt:new Date(Date.now()-Math.random()*365*86400000).toISOString(),
  lastLogin:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
  orders:Math.floor(Math.random()*100),totalSpent:Math.floor(Math.random()*50000),
}));

export const getRestaurants = () => Array.from({length:40},(_,i)=>({
  id:`REST${String(i+1).padStart(4,'0')}`,name:RESTAURANTS[i%10],
  owner:['Ramesh Kumar','Suresh Patel','Mahesh Reddy','Dinesh Singh','Lokesh Nair'][i%5],
  email:`restaurant${i+1}@example.com`,phone:`+91 ${8000000000+i}`,
  city:CITIES[i%5],cuisine:['Biryani','North Indian','South Indian','Mughlai','Multi-Cuisine'][i%5],
  status:[STATUS.ACTIVE,STATUS.PENDING,STATUS.INACTIVE][i%3],
  rating:(3.5+Math.random()*1.5).toFixed(1),
  totalOrders:Math.floor(Math.random()*5000),revenue:Math.floor(Math.random()*500000),
  commission:15+(i%5),verified:i%3!==1,
  avgPrepTime:15+(i%15),pickupOnTime:70+(i%25),
  createdAt:new Date(Date.now()-Math.random()*365*86400000).toISOString(),
}));

export const getOrders = () => Array.from({length:60},(_,i)=>{
  const status=PICKUP_STATUSES[i%7];
  const placedAt=new Date(Date.now()-Math.random()*7*86400000).toISOString();
  return {
    id:`ORD${String(100000+i)}`,pickupToken:`TKN${String(2000+i)}`,
    customer:CUSTOMERS[i%5],customerId:`CUST${String(i+1).padStart(4,'0')}`,
    restaurant:RESTAURANTS[i%5],restaurantId:`REST${String((i%5)+1).padStart(4,'0')}`,
    items:Math.floor(Math.random()*5)+1,amount:Math.floor(Math.random()*2000)+200,
    commission:Math.floor(Math.random()*300)+30,taxes:Math.floor(Math.random()*100)+20,
    status,paymentMethod:['UPI','Card','Cash','Wallet'][i%4],
    paymentStatus:['paid','pending','failed','refunded'][i%4],
    prepTimeMinutes:15+(i%15),placedAt,
    estimatedReadyAt:new Date(new Date(placedAt).getTime()+(15+(i%15))*60000).toISOString(),
    pickedUpAt:status==='completed'?new Date(new Date(placedAt).getTime()+(25+i%20)*60000).toISOString():null,
    cancellationReason:status==='cancelled'?['Changed mind','Ordered by mistake','Too long wait'][i%3]:null,
    rejectionReason:status==='rejected'?['Kitchen closed','Item unavailable','Too busy'][i%3]:null,
  };
});

export const getCustomers = () => Array.from({length:45},(_,i)=>({
  id:`CUST${String(i+1).padStart(4,'0')}`,name:CUSTOMERS[i%10],
  email:`customer${i+1}@example.com`,phone:`+91 ${7000000000+i}`,
  status:[STATUS.ACTIVE,STATUS.INACTIVE][i%2],
  totalOrders:Math.floor(Math.random()*200),totalSpent:Math.floor(Math.random()*100000),
  walletBalance:Math.floor(Math.random()*5000),rewardPoints:Math.floor(Math.random()*2000),
  city:CITIES[i%5],pickupRate:70+Math.floor(Math.random()*30),
  avgPickupDelay:Math.floor(Math.random()*15),
  joinedAt:new Date(Date.now()-Math.random()*365*86400000).toISOString(),
  lastOrder:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
}));

export const getSupportTickets = () => Array.from({length:40},(_,i)=>({
  id:`TKT${String(10000+i)}`,
  subject:['Order not ready on time','Wrong item in order','Refund not processed',
    'App crash issue','Payment failed','Restaurant closed but accepted order',
    'Food quality issue','Pickup token not working'][i%8],
  customer:`Customer ${i+1}`,email:`customer${i+1}@example.com`,
  category:['Order Issue','Payment','Food Quality','App Bug','Refund'][i%5],
  priority:['high','medium','low'][i%3],
  status:[STATUS.OPEN,STATUS.RESOLVED,STATUS.CLOSED][i%3],
  createdAt:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
  updatedAt:new Date(Date.now()-Math.random()*7*86400000).toISOString(),
  assignedTo:['Support Agent 1','Support Agent 2','Support Agent 3'][i%3],
}));

export const getLegalVerifications = () => Array.from({length:30},(_,i)=>({
  id:`LGL${String(i+1).padStart(4,'0')}`,restaurantName:RESTAURANTS[i%4],
  gstNumber:`29ABCDE${1000+i}F1Z5`,panNumber:`ABCDE${1000+i}F`,licenseNumber:`FSSAI${20000+i}`,
  status:[STATUS.PENDING,STATUS.APPROVED,STATUS.REJECTED][i%3],
  submittedAt:new Date(Date.now()-Math.random()*60*86400000).toISOString(),
  reviewedAt:i%3!==0?new Date(Date.now()-Math.random()*30*86400000).toISOString():null,
  reviewedBy:i%3!==0?'Admin User':null,remarks:i%3===2?'Documents expired or invalid':'',
}));

export const getCommissionData = () => Array.from({length:30},(_,i)=>({
  id:`COM${String(i+1).padStart(4,'0')}`,restaurantName:RESTAURANTS[i%5],
  totalOrders:Math.floor(Math.random()*500)+100,
  grossRevenue:Math.floor(Math.random()*200000)+50000,
  commissionRate:15+(i%5),commissionAmount:Math.floor(Math.random()*30000)+8000,
  platformFee:Math.floor(Math.random()*5000)+1000,netPayout:Math.floor(Math.random()*170000)+40000,
  avgOrderValue:Math.floor(Math.random()*600)+300,
  period:`${['Jan','Feb','Mar','Apr','May'][i%5]} 2026`,status:['paid',STATUS.PENDING][i%2],
}));

export const getSettlements = () => Array.from({length:25},(_,i)=>({
  id:`SET${String(10000+i)}`,settlementId:`SET${String(10000+i)}`,
  entityName:RESTAURANTS[i%5],entityType:'restaurant',
  period:`${['May','Apr','Mar','Feb','Jan'][i%5]} 2026`,
  amount:Math.floor(Math.random()*500000)+100000,
  deductions:Math.floor(Math.random()*75000)+15000,
  netAmount:Math.floor(Math.random()*415000)+83000,
  status:['completed',STATUS.PENDING,'processing'][i%3],
  bankName:['HDFC Bank','ICICI Bank','SBI'][i%3],accountNumber:`XXXX${1000+i}`,
  createdAt:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
  paidAt:i%3===0?new Date(Date.now()-Math.random()*10*86400000).toISOString():null,
}));

export const getCancellations = () => Array.from({length:30},(_,i)=>({
  id:`CAN${String(10000+i)}`,orderId:`ORD${String(100000+i)}`,
  customerName:`Customer ${i+1}`,restaurantName:RESTAURANTS[i%3],
  amount:Math.floor(Math.random()*1500)+200,
  reason:['Changed mind','Ordered by mistake','Long wait time','Wrong items selected','Food unavailable'][i%5],
  cancelledBy:['customer','restaurant','system'][i%3],
  refundStatus:['completed',STATUS.PENDING,'not_applicable'][i%3],
  refundAmount:Math.floor(Math.random()*1500),
  cancelledAt:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
}));

export const getRejections = () => Array.from({length:25},(_,i)=>({
  id:`REJ${String(10000+i)}`,orderId:`ORD${String(200000+i)}`,
  customerName:`Customer ${i+1}`,restaurantName:RESTAURANTS[i%3],
  amount:Math.floor(Math.random()*1500)+200,
  reason:['Kitchen closed','Item unavailable','Too busy','Ingredient shortage','System issue'][i%5],
  rejectedBy:['restaurant','system'][i%2],
  refundStatus:['completed',STATUS.PENDING][i%2],
  rejectedAt:new Date(Date.now()-Math.random()*30*86400000).toISOString(),
}));

export const getRoles = () => [
  {id:1,name:ROLES.SUPER_ADMIN,users:1,permissions:'All',description:'Full system access'},
  {id:2,name:ROLES.ADMIN,users:3,permissions:'Most',description:'Admin access excluding system settings'},
  {id:3,name:ROLES.FINANCE_MANAGER,users:5,permissions:'Finance',description:'Revenue, payouts, settlements'},
  {id:4,name:ROLES.RESTAURANT_MANAGER,users:12,permissions:'Restaurants',description:'Restaurant management'},
  {id:5,name:ROLES.SUPPORT_EXECUTIVE,users:18,permissions:'Support',description:'Ticket handling'},
  {id:6,name:ROLES.OPERATIONS_MANAGER,users:7,permissions:'Operations',description:'Orders, pickup queue, analytics'},
];

export const getTestLogs = () => Array.from({length:30},(_,i)=>({
  id:`TEST${String(i+1).padStart(4,'0')}`,
  module:['Authentication','Takeaway Orders','Payments','Restaurants','Pickup Queue','Notifications'][i%6],
  testName:`Test Case ${i+1}`,type:['unit','integration','e2e'][i%3],
  status:['passed','failed','skipped'][i%3],
  duration:+(Math.random()*2+0.1).toFixed(2),
  runAt:new Date(Date.now()-Math.random()*7*86400000).toISOString(),
  error:i%3===1?'AssertionError: expected 200 got 404':null,
}));

export const getBankDetails = () => Array.from({length:20},(_,i)=>({
  id:`BNK${String(i+1).padStart(4,'0')}`,entityName:RESTAURANTS[i%5],entityType:'restaurant',
  accountHolder:['Ramesh Kumar','Suresh Patel','Mahesh Reddy','Dinesh Singh'][i%4],
  bankName:['HDFC Bank','ICICI Bank','SBI','Axis Bank','Kotak Bank'][i%5],
  branch:['Hyderabad Main','Bangalore MG Road','Mumbai Andheri','Chennai Anna Nagar'][i%4],
  accountNumber:`40${String(20000000+i)}`,ifscCode:`HDFC${String(i+1).padStart(7,'0')}`,
  accountType:['Current','Savings'][i%2],
  verificationStatus:['verified','pending','rejected'][i%3],
  createdAt:new Date(Date.now()-Math.random()*90*86400000).toISOString(),
}));

export const getFoodCompliance = () => Array.from({length:25},(_,i)=>({
  id:`FSSAI${String(i+1).padStart(4,'0')}`,restaurant:RESTAURANTS[i%4],
  licenseNumber:`FSSAI${21000+i}`,licenseType:['Basic','State','Central'][i%3],
  issuedDate:new Date(Date.now()-(365+i*10)*86400000).toISOString(),
  expiryDate:new Date(Date.now()+(i%4===0?-10:180+i*5)*86400000).toISOString(),
  status:i%4===0?'expired':[STATUS.ACTIVE,STATUS.PENDING][i%2],
  verifiedBy:i%2===0?'Admin':null,
}));

export const getPreparationAnalytics = () => Array.from({length:20},(_,i)=>({
  id:`REST${String((i%10)+1).padStart(4,'0')}`,restaurantName:RESTAURANTS[i%10],city:CITIES[i%5],
  totalOrdersThisMonth:Math.floor(Math.random()*800)+100,
  avgPrepTimeMinutes:15+(i%15),targetPrepMinutes:20,
  onTimeRate:70+Math.floor(Math.random()*28),delayedOrders:Math.floor(Math.random()*80),
  peakHour:`${11+(i%4)}:00`,completionRate:80+Math.floor(Math.random()*18),
  cancellationRate:2+Math.floor(Math.random()*8),efficiency:Math.floor(80+Math.random()*19),
}));

export const getPickupAnalytics = () => ({
  overallPickupRate:94.2,noShowRate:5.8,avgPickupDelay:4.5,
  pickupRateByCity:[
    {city:'Hyderabad',rate:96.1},{city:'Bangalore',rate:93.4},
    {city:'Mumbai',rate:91.8},{city:'Chennai',rate:95.2},{city:'Delhi',rate:94.7},
  ],
  delayBuckets:[
    {label:'0–5 min',count:820},{label:'5–15 min',count:340},
    {label:'15–30 min',count:120},{label:'30+ min',count:48},
  ],
  repeatPickupRate:72.4,
  monthlyTrend:[
    {month:'Jan',pickupRate:91},{month:'Feb',pickupRate:92},{month:'Mar',pickupRate:93},
    {month:'Apr',pickupRate:94},{month:'May',pickupRate:94},{month:'Jun',pickupRate:95},
  ],
});

// Legacy alias kept for backward compat
export const getDeliveryPartners = () => [];
export const getDeliveryZones = () => [];
